import { BaseService } from "../baseService";
import { TransferOrderAPIService } from "./transferOrderAPIService";
import { sanitiseParams } from "src/utils/sanitiser";
import { GetTransferOrdersQueryParams } from "src/types/api";

class TransferOrderService extends BaseService<TransferOrderAPIService> {
  async createManualTransferOrder(products: Array<{ productId: string; euQuantity: number; extraInfo?: string }>) {
    return await this.apiService.postTransferOrdersManual({ products });
  }

  @sanitiseParams()
  async getTransferOrders(queryParams: GetTransferOrdersQueryParams) {
    return await this.apiService.getTransferOrders(queryParams);
  }

  @sanitiseParams()
  async getTransferOrderById(transferOrderId: string) {
    return await this.apiService.getTransferOrderById(transferOrderId);
  }
}

export { TransferOrderService };
